import { render, staticRenderFns } from "./TestingComponents.vue?vue&type=template&id=d3222c2e&scoped=true"
import script from "./TestingComponents.vue?vue&type=script&lang=js"
export * from "./TestingComponents.vue?vue&type=script&lang=js"
import style0 from "./TestingComponents.vue?vue&type=style&index=0&id=d3222c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3222c2e",
  null
  
)

export default component.exports